<ng-container *ngIf="HasRequiredPermissions">

  <div class="bg-white p-6 rounded-lg shadow w-full max-w-none" [class.my-8]="!isNested" [class.my-4]="isNested">
    <div class="mb-6">
      <h1 class="text-lg font-medium text-gray-700 mb-4" data-testid="list-title">
        {{ `entities.${entityMetaData.EntityName.toLowerCase()}.pluralName` | translate }} ({{ totalSeen }}/{{ listView()?.entities()?.total }})
      </h1>
    </div>
    <app-list-view [entityType]="ComponentEntityClass"
      [contextMenuItems]="contextMenuItems"
      [showActions]="true"
      [canEdit]="canEdit.bind(this)"
      (entitySelected)="selectSingleItem($event)"
      (editAction)="editSelectedItem($event)"
      (deleteAction)="deleteSelectedItem($event)"
      [dismissEntity]="dismissEntityState.bind(this)"
      [onDismissAdded]="dismissEntityState.bind(this)"
      [onRowDismiss]="handleRowDismiss.bind(this)"
      [pagination]="{
                          enabled: true,
                          pageLengths: [5, 10, 20, 50, 100, 300],
                          defaultPageLength: 5,
                          searchColumns: null,
                          sortableColumns: null
                        }"
      [paginatorType]="'button'"
      [showHeader]="false"
      (createButtonClick)="openCreateModal()">
      <!-- Colonne Photo -->
      <app-list-table-column key="imagePhoto.thumbnail_Path" title="{{ 'photo' | translate }}" type="custom">
        <ng-template #customTemplate let-entity>
          <div class="w-12 h-12 bg-gray-100 rounded-[4px] flex items-center justify-center overflow-hidden border border-[3px] border-gray-200 shadow-lg">
            @if (entity.imagePhoto?.thumbnail_Path) {
            <img [src]="rootUrl+ entity.imagePhoto.thumbnail_Path" alt="Employee Photo" class="w-full h-full object-contain">
            } @else {
            <img src="/assets/images/user-regular.svg" alt="Employee Photo" class="w-full h-full object-contain">
            }
          </div>
        </ng-template>
      </app-list-table-column>
      <!-- Colonne FullName -->
      <app-list-table-column key="fullName" title="{{ 'entities.employee.propreties.fullName' | translate }}" type="text" [sortable]="true" align="left"></app-list-table-column>
      <!-- Colonne POS -->
      <app-list-table-column key="employeePOS" title="{{ 'entities.employee.propreties.pos' | translate }}" type="custom">
        <ng-template #customTemplate let-entity>
          <div class="flex flex-wrap gap-1">
            @for (ep of entity.employeePOS; track ep.fK_PointOfService) {
            <app-reactive-badge
              [status]="ep.fK_PointOfService"
              [lookupData]="posLookup()"
              [Skin]="Skin"
              [isEditMode]="false">
            </app-reactive-badge>
            }
          </div>
        </ng-template>
      </app-list-table-column>
      <!-- Colonne Status -->
      <app-list-table-column key="status" title="{{ 'entities.employee.propreties.status' | translate }}" type="custom">
        <ng-template #customTemplate let-entity>
          <app-reactive-badge [status]="$safeNavigationMigration(entity?.status)"
            [lookupData]="employeeStatusLookup()"
            [Skin]="Skin"
            [isEditMode]="true"
            (statusChange)="updateEntityProperty(entity, 'status', $event)"></app-reactive-badge>
        </ng-template>
      </app-list-table-column>

      <!-- Colonne Approve -->
      <app-list-table-column key="approve" title="{{ 'vues.employee.list.columns.approve' | translate }}" type="custom">
        <ng-template #customTemplate let-entity>
          <app-reactive-badge [lookupData]="approveLookupArray"
            [status]="1"
            [Skin]="Skin"
            [isEditMode]="true"
            (statusChange)="doSpecialAction(entity,  'approve', $event)"></app-reactive-badge>
        </ng-template>
      </app-list-table-column>
      <!-- Colonne Notify -->
      <app-list-table-column key="notify" title="{{ 'vues.employee.list.columns.notify' | translate }}" type="custom">
        <ng-template #customTemplate let-entity>
          <app-reactive-badge [lookupData]="notifyLookupArray"
            [status]="1"
            [Skin]="Skin"
            [isEditMode]="true"
            (statusChange)="doSpecialAction(entity,  'notify', $event)"></app-reactive-badge>
        </ng-template>
      </app-list-table-column>
    </app-list-view>

    <!--Vue de detail-->
    <div class="fixed top-0 right-0 h-full z-50 min-w-[350px]"
      [style.width.px]="currentWidth()"
      [hidden]="!isModalOpen()">

      <!-- Poignee interactive (invisible avant le survol)  -->
      <div class="absolute left-0 top-0 h-full w-2 hover:w-3 hover:bg-gray-600 hover:shadow-md cursor-[ew-resize] transition-all z-[999]"
        (mousedown)="startResize($event)">
      </div>
      <div class="bg-white rounded-lg shadow-xl p-1 h-full">
        <app-employee-detail #employeeDetail
          [isModal]="true"
          [dataService]="dataService"
          (closeModal)="closeModal($event)"
          (itemSaved)="onItemUpdated($event)"
          (databaseUpdated)="closeModal(true)"
          [EntityInstance]="selectedItem()">
        </app-employee-detail>
      </div>
    </div>

  </div>

</ng-container>